import { render, staticRenderFns } from "./veStuAssocFundsAdmin.vue?vue&type=template&id=54a28285&scoped=true"
import script from "./veStuAssocFundsAdmin.vue?vue&type=script&lang=js"
export * from "./veStuAssocFundsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a28285",
  null
  
)

export default component.exports